import { render } from "./person-role-delete.vue?vue&type=template&id=3036bca8"
import script from "./person-role-delete.vue?vue&type=script&lang=js"
export * from "./person-role-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__